import React from 'react'

import clsx from 'clsx'

import Review from 'components/Review'
import Typography from 'components/Typography'

import NoSnippets from './components/NoSnippets'

import classes from './ReviewsSnippets.module.scss'

/** @type {import("./types").default} */
const ReviewsSnippets = ({ snippets = [], snippetSize = 'small', type = 'pros' }) => {
  const isPros = type === 'pros'

  return (
    <div className={clsx('ReviewsSnippets', classes.reviewSnippetsGeneral)}>
      <div className={classes.titleContainer}>
        <Typography className={classes.reviewsSection}>{isPros ? 'Pros' : 'Cons'}</Typography>
      </div>
      {snippets.length > 0 ? (
        snippets.slice(0, 3).map(snippet => (
          <div className={classes.snippetWrapper} key={snippet.text}>
            {/* TO DO: Once compare API is updated with review snippet additional info
             pass reviewerName (name of reviewer or Verified Reviewer) and href props */}
            <Review.Snippet
              data-testid="reviews_snippets-review_snippet"
              size={snippetSize}
              snippet={snippet}
              type={type}
            />
          </div>
        ))
      ) : (
        <NoSnippets />
      )}
    </div>
  )
}

export default ReviewsSnippets
